import {AksjeeierBeholdningModell, AksjeeierEnkelModell} from "../tjenester/ressurser/generertNg2HttpKlient";
import {erNil} from "../støttefunksjoner/nilsjekk";
import {nil} from "felles-ng2/typer/nullish";

/** Sorterer aksjeeier etter navn */
export function sorterAksjeeier(a: AksjeeierEnkelModell, b: AksjeeierEnkelModell): number {
    return a.navn.toLocaleLowerCase().localeCompare(b.navn.toLocaleLowerCase());
}

export function aksjeeierHarBeholdning(aksjeeier: AksjeeierEnkelModell): boolean {
    return harBeholdning(aksjeeier.naavaerendeBeholdning);
}

export function harBeholdning(beholdning: AksjeeierBeholdningModell | nil): boolean {
    if (erNil(beholdning)) return false;
    return beholdning.antall > 0;
}
